import { ChangeEvent, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { handleAiModel } from 'src/store/actions/aiModel';
import { useAppDispatch, useAppSelector } from 'universal-scripts';

import './SelectAIModel.sass';

export enum AIModelEnum {
	NoFoundModel = '',
	Gpt4 = 'gpt-4',
	Llama38B = 'Llama3-8B',
	Gpt4OMini = 'gpt-4o-mini',
	Gpt4O = 'gpt-4o'
}

const SelectAIModel = () => {
	const dispatch = useAppDispatch();
	const storeAiModel = useAppSelector((s: { aiModel: AIModelEnum }) => s.aiModel);
	const [aiModel, setAiModel] = useState(storeAiModel);

	const enumValues = Object.values(AIModelEnum);
	if (!enumValues.includes(aiModel)) {
		setAiModel(AIModelEnum.NoFoundModel);
	}

	useEffect(() => {
		dispatch(handleAiModel(aiModel as AIModelEnum));
	}, [aiModel, dispatch]);

	const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
		setAiModel(e.target.value as AIModelEnum);
	};

	if (__DEV__) {
		return (
			<select id="select-ai-model" value={aiModel} onChange={handleChange}>
				<option value="" disabled>
					<FormattedMessage id="select" />
				</option>
				{Object.entries(AIModelEnum).map(([key, value]) => (
					<option key={key} value={value}>
						{value}
					</option>
				))}
			</select>
		);
	}
};

export default SelectAIModel;
